const contextMenuIconsMap = {
  copy: {
    default: 'my-lesson-gallery-copy-slides-medium-default',
    disabled: 'my-lesson-gallery-copy-slides-medium-disabled'
  },
  paste: {
    default: 'my-lesson-gallery-paste-medium-default',
    disabled: 'my-lesson-gallery-paste-medium-disabled'
  },
  duplicate: {
    default: 'content-and-activities-misc-duplicate-medium-black',
    disabled: 'content-and-activities-misc-duplicate-medium-black-disabled'
  },
  delete: {
    default: 'content-and-activities-misc-delete-default',
    disabled: 'content-and-activities-misc-delete-disabled'
  },
  convert: {
    default: 'content-and-activities-drawit-convert-medium-default',
    disabled: 'content-and-activities-drawit-redo-medium-disabled'
  },
  'add-quick-slide': {
    default: 'content-creation-add-quick-slide-small-default',
    disabled: 'content-creation-add-quick-slide-small-disabled'
  },
  'file-upload': {
    default: 'content-creation-file-upload-small-default',
    disabled: 'content-creation-file-upload-small-disabled'
  },
  'add-quiz': {
    default: 'content-creation-add-quiz-small-default',
    disabled: 'content-creation-add-quiz-small-disabled'
  }
};

export { contextMenuIconsMap };
//# sourceMappingURL=ContextMenu.shared.js.map
